export const SETUP_COLORS = { breakout: '#22d3ee', pullback: '#fbbf24' };

export function suggestionLevels(scenarios = []) {
  if (!Array.isArray(scenarios)) return [];
  return ['breakout', 'pullback'].flatMap(setup => {
    const scenario = scenarios.find(item => item?.id === setup);
    if (!scenario) return [];
    return [['entry', scenario.entry], ['exit', scenario.target]].flatMap(([action, price]) => (
      typeof price === 'number' && Number.isFinite(price) && price > 0
        ? [{ id: `${setup}-${action}`, setup, action, price, color: SETUP_COLORS[setup] }] : []
    ));
  });
}